import React, { Component } from 'react';

import ChargeButton from '../containers/ChargeButton';
import OrderInfo from '../containers/OrderInfo';
import * as shapes from '../../shapes';

class Layout extends Component {
  static propTypes = {
    children: shapes.children.isRequired,
  };

  constructor(props) {
    super(props);
    this.height = 0;
  }

  componentDidUpdate() {
    // Scroll sidebar to bottom when new items are added
    if (this.sidebar.scrollHeight > this.height) {
      this.sidebar.scrollTop = this.sidebar.scrollHeight;
    }
    this.height = this.sidebar.scrollHeight;
  }

  render() {
    const { children } = this.props;

    return (
      <div className="c-register-layout">
        <div className="c-register-layout__main">{children}</div>
        <div
          className="c-register-layout__sidebar"
          ref={(el) => { this.sidebar = el; }}
        >
          <div className="u-flex-1 u-co-gray-2 epsilon u-type--light">
            <OrderInfo />
          </div>
          <div className="c-register-charge-button">
            <ChargeButton />
          </div>
        </div>
      </div>
    );
  }
}
export default Layout;
